import React from "react";
import { Card, Divider, Typography } from "@mui/material";

import useStyles from "./CropTypeDetailsStyles";

function CropTypeContainer(props) {
  const classes = useStyles();

  return (
    <>
      {
        <Card elevation={3} className={classes.cropTypeCard}>
          {/* <p className='text__center m__b__10 green__text'>धान के प्रकार</p>
              <div className={classes.contentWrapper}> 
              <div className={classes.detailsContainer}>
                 <p>आपका धान</p>
                  <p className={classes.greenColor}>{props.cropVariety}</p>
                </div>
              
                <Divider flexItem orientation='vertical' className={classes.dividerColor} />
              
                <div className={classes.detailsContainer}>
                <p>लोकप्रिय धान</p>
                  <p>{props.popularVariety}</p>
                </div>
                </div> */}

          <div className={classes.icons}>
            <span className={classes.countCircle}>3</span>
            <span>
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5641 0.00281261C12.3931 -0.0444887 11.2787 0.50736 10.6066 1.46715L0.919334 15.2946C0.396205 16.0416 0.191201 16.966 0.349182 17.8641C0.507415 18.7625 1.01562 19.5613 1.76256 20.0847L17.7286 31.2734V31.2737C17.8026 31.3249 17.8987 31.3325 17.9795 31.2928C18.0605 31.2531 18.1138 31.1729 18.1183 31.0828C18.1687 30.1635 18.6321 29.3163 19.3788 28.778C20.1254 28.2393 21.0754 28.0673 21.9637 28.3095C22.0273 28.3263 22.0952 28.3171 22.1524 28.2838C22.2092 28.2506 22.2506 28.1957 22.2672 28.1318C22.5147 27.1959 23.1921 26.4332 24.0922 26.077C24.9924 25.7208 26.0082 25.8135 26.829 26.3267C26.8957 26.369 26.9785 26.3768 27.052 26.3481C27.1255 26.3194 27.1809 26.2575 27.2015 26.1814C27.4208 25.3706 27.9651 24.6864 28.7055 24.2903C29.4463 23.8941 30.3174 23.8212 31.1137 24.0887C31.2178 24.123 31.3322 24.0847 31.3949 23.9949L35.138 18.6552V18.6549C35.6616 17.908 35.8675 16.9834 35.7095 16.0846C35.5516 15.1862 35.0431 14.3868 34.2961 13.8632L15.4001 0.623847C14.8601 0.245155 14.223 0.029764 13.5641 0.0030158L13.5641 0.00281261ZM17.2702 10.2653V10.2656C17.7933 10.2749 18.2914 10.4905 18.6563 10.8656C19.0209 11.2406 19.2225 11.7449 19.2171 12.268C19.2134 12.4172 19.2914 12.5569 19.4207 12.6321C19.5499 12.7069 19.7098 12.7055 19.8377 12.6284C20.2938 12.348 20.8437 12.2641 21.3625 12.3955C21.8814 12.527 22.3251 12.8626 22.5926 13.3261C22.8604 13.7898 22.9291 14.3417 22.7835 14.8569C22.638 15.3718 22.2902 15.806 21.8195 16.0608C21.6885 16.1326 21.6069 16.2703 21.6069 16.4198C21.6069 16.569 21.6885 16.7067 21.8195 16.7785C22.2902 17.0333 22.6379 17.4674 22.7835 17.9827C22.9291 18.4977 22.8604 19.0498 22.5926 19.5132C22.3252 19.9769 21.8814 20.3125 21.3625 20.444C20.8436 20.5752 20.2938 20.4913 19.8377 20.2112C19.7101 20.134 19.5505 20.1323 19.4215 20.2069C19.2923 20.2818 19.214 20.4209 19.2171 20.5699C19.2171 21.2783 18.8393 21.9332 18.2258 22.2873C17.6122 22.6415 16.8563 22.6415 16.2427 22.2873C15.6289 21.9331 15.2511 21.2783 15.2511 20.5699C15.2542 20.4209 15.1759 20.2818 15.047 20.2069C14.9177 20.1323 14.7581 20.134 14.6305 20.2112C14.1744 20.4936 13.6234 20.5792 13.1031 20.4482C12.5829 20.3173 12.1376 19.9811 11.8697 19.5166C11.6016 19.0517 11.5332 18.4982 11.6802 17.9824C11.8272 17.4663 12.1768 17.0321 12.6496 16.7784C12.7808 16.7067 12.8621 16.569 12.8621 16.4197C12.8621 16.2702 12.7808 16.1326 12.6496 16.0608C12.1768 15.8074 11.8271 15.3729 11.6802 14.8568C11.5332 14.341 11.6016 13.7875 11.8697 13.3229C12.1377 12.8581 12.5828 12.5219 13.1031 12.3913C13.6235 12.2603 14.1744 12.3457 14.6305 12.6283C14.7584 12.7055 14.9183 12.7069 15.0475 12.632C15.1768 12.5568 15.2548 12.4172 15.2511 12.2679C15.2457 11.7321 15.4572 11.2172 15.8376 10.8399C16.218 10.4629 16.7346 10.2554 17.2701 10.2656L17.2702 10.2653Z"
                  fill="black"
                />
                <path
                  d="M18.4394 16.4193C18.4428 16.0977 18.3175 15.788 18.0914 15.5594C17.8654 15.3307 17.5571 15.2021 17.2355 15.2021C16.9137 15.2021 16.6054 15.3308 16.3793 15.5594C16.1532 15.788 16.0279 16.0977 16.0313 16.4193C16.0279 16.7411 16.1532 17.0505 16.3793 17.2792C16.6054 17.5078 16.9137 17.6365 17.2355 17.6365C17.5571 17.6365 17.8654 17.5078 18.0914 17.2792C18.3175 17.0505 18.4428 16.7411 18.4394 16.4193Z"
                  fill="black"
                />
                <path
                  d="M27.2077 29.1C27.0791 30.0136 27.3649 30.9371 27.9865 31.6188C28.6085 32.3004 29.5018 32.6692 30.4237 32.6247C30.552 31.7111 30.2665 30.7876 29.6446 30.106C29.0226 29.4243 28.1293 29.0555 27.2077 29.1H27.2077Z"
                  fill="black"
                />
                <path
                  d="M30.266 35.8652C29.9028 35.0172 29.1806 34.3752 28.2957 34.1139C27.4111 33.8527 26.4558 33.9996 25.6902 34.5146C26.0534 35.3627 26.7756 36.0046 27.6605 36.2659C28.5455 36.5272 29.5005 36.3802 30.266 35.8652Z"
                  fill="black"
                />
                <path
                  d="M35.6301 27.4912C34.7452 27.7502 34.0219 28.39 33.6564 29.2366C33.2912 30.0829 33.3222 31.0484 33.7408 31.8697C34.6255 31.6106 35.349 30.9709 35.7143 30.1243C36.0794 29.278 36.0488 28.3125 35.6301 27.4912H35.6301Z"
                  fill="black"
                />
                <path
                  d="M32.0903 36.421C32.8401 36.9579 33.7904 37.1327 34.6823 36.8979C35.574 36.6628 36.3148 36.0426 36.703 35.206C35.953 34.6691 35.0027 34.4943 34.111 34.7294C33.2191 34.9642 32.4783 35.5844 32.0903 36.421V36.421Z"
                  fill="black"
                />
              </svg>

              <p>{props.label.cropTypeTitle}</p>
            </span>
          </div>
          <div className={classes.cropTypeDetails}>
            <div>
              <Typography variant="h6">{props.cropVariety}</Typography>
              <Typography variant="h6" className={classes.cropTypeTitle}>
                {props.label.cropType}
              </Typography>
            </div>
            <div>
              <Typography variant="h6" className={classes.cropType}>
                {props.popularVariety}
              </Typography>
              <Typography variant="h6" className={classes.cropTypeTitle}>
                {props.label.famousCropType}
              </Typography>
            </div>
          </div>
        </Card>
      }
    </>
  );
}

export default CropTypeContainer;
